export const contactDisplayName = (contact = {}) => {
  const providedDisplayName = typeof contact.display_name === 'string'
    ? contact.display_name.trim()
    : ''
  if (providedDisplayName) {
    return providedDisplayName
  }

  const fullName = typeof contact.full_name === 'string'
    ? contact.full_name.trim().replace(/,\s*$/, '')
    : ''
  if (fullName) {
    return fullName
  }

  const lastName = typeof contact.last_name === 'string' ? contact.last_name.trim() : ''
  const firstName = typeof contact.first_name === 'string' ? contact.first_name.trim() : ''
  const personalName = [lastName, firstName].filter(Boolean).join(', ')

  return personalName || (typeof contact.company === 'string' ? contact.company.trim() : '')
}

export const withContactDisplayName = (contact = {}) => ({
  ...contact,
  display_name: contactDisplayName(contact)
})

export const mergeContactDisplayName = (previous = {}, patch = {}) => {
  const contact = { ...previous, ...patch }
  const identityChanged = ['first_name', 'last_name', 'company'].some(key =>
    Object.prototype.hasOwnProperty.call(patch, key) && patch[key] !== previous[key]
  )
  if (identityChanged) {
    // Partial offline edits carry no refreshed server-derived names.
    contact.full_name = [contact.last_name, contact.first_name]
      .map(value => typeof value === 'string' ? value.trim() : '')
      .filter(Boolean).join(', ')
    delete contact.display_name
  }
  return withContactDisplayName(contact)
}

export const withContactDisplayNames = (contacts = {}) => Object.keys(contacts).reduce((normalized, id) => {
  normalized[id] = withContactDisplayName(contacts[id])
  return normalized
}, {})
